"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForgotPassword = void 0;

var _tslib = require("tslib");

var _useRequest = _interopRequireDefault(require("../useRequest/useRequest"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var useForgotPassword = function useForgotPassword(parameters, isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'post',
    path: 'account/forgotPassword',
    params: (0, _tslib.__assign)({}, parameters)
  }, isAsync);
};

exports.useForgotPassword = useForgotPassword;